/** Classes that keep the studio tab strip on screen while the transcript grows. */
export const CHAT_SHELL_CLASS =
  'flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden bg-bg';

export const CHAT_TRANSCRIPT_CLASS =
  'flex-1 min-h-0 overflow-y-auto px-4 py-5 space-y-4';

/** Scroll only the transcript. scrollIntoView walks overflow:hidden ancestors and hides the Graph/Chat tabs. */
export function scrollTranscriptToEnd(scroller: HTMLElement | null) {
  if (!scroller) return;
  scroller.scrollTop = scroller.scrollHeight;
}
